import { downloadCSVFile, getPathAPI } from "@/helpers";
import { AxiosRequestConfig } from "axios";
import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

export type IEzlynxQuotesExportPayload = {
  startDate?: string;
  endDate?: string;
  status?: string[];
  path: string;
};

class EzlynxQuotesReportService extends BaseCollectionService {
  constructor() {
    super("export-ezlynx-submitted-quotes");
  }
  public async exportEzlynxSubmittedQuotes(
    payload: IEzlynxQuotesExportPayload
  ): Promise<ResponseWrapper> {
    const axiosConfig: AxiosRequestConfig = {
      baseURL: getPathAPI(),
      url: payload.path,
      method: "GET",
      responseType: "blob",
      params: {
        startDate: payload.startDate,
        endDate: payload.endDate,
        status: payload.status
      }
    };

    let response;
    try {
      response = await this.request(axiosConfig, { useToken: "access" });
    } catch (error) {
      const blob = error?.raw?.response?.data;
      if (blob instanceof Blob) {
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          throw new Error(
            json.response?.message ||
              json.message ||
              json.error ||
              "Failed to export EzLynx submitted quotes"
          );
        } catch (parseError) {
          if (parseError instanceof SyntaxError) {
            throw new Error(
              error.message || "Failed to export EzLynx submitted quotes"
            );
          }
          throw parseError;
        }
      }
      throw error;
    }

    downloadCSVFile(response.data, "EzLynxSubmittedQuotesReport.csv");

    return response;
  }
}

export default new EzlynxQuotesReportService();
